
import { Expand, Eye, ImageOffIcon } from "lucide-react";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { routes } from "routes";




type BoxServerImageType = {
    src?: string
    enebleShowInDialog?: boolean
}

export const BoxServerImage = ({ src, enebleShowInDialog = true }: BoxServerImageType) => {

    const [showImage, setShowImage] = useState<boolean>(false);



    if (!src) return <div className=" w-full h-full bg-primary-50 rounded-lg  flex justify-center items-center  " > <ImageOffIcon className={" text-primary "} /> </div>;


    src = src.startsWith("http") ? src : process.env.REACT_APP_API_URL + routes.api.images + "/" + src;

    return <div

        className=" relative w-full h-full border border-primary-300 group overflow-hidden rounded-lg "
    >
        {/* <Dialog
            visible={showImage}
            onHide={() => setShowImage(false)}
            modal
            style={{ width: "600px" }}
            content={()=>  <DialogContent
                title="Resim Önizleme"
                onCancel={() => setShowImage(false)}
            >
                {src ? (
                    <div className="flex justify-center items-center h-full">
                        <img
                            src={src}
                            alt="preview"
                            className="max-w-full max-h-[400px] object-contain rounded"
                        />
                    </div>
                ) : (
                    <p className="text-center text-gray-400">
                        Resim bulunamadı
                    </p>
                )}
            </DialogContent>}
        /> */}

        <div className={`${enebleShowInDialog && "bg-gray-100"}   w-full h-full   flex items-center justify-center `} >
            <img
                className=" w-full h-full  object-cover      "
                alt="i"
                src={src}
            />
        </div>


        {/* {enebleShowInDialog && <div className="absolute bottom-1 end-1 p-2 bg-white/90 backdrop-blur-sm border border-primary/20 rounded-full 
                           opacity-0   group-hover:opacity-100 transition-all duration-300 shadow-lg 
                            hover:scale-110 cursor-pointer" >
            <Expand
                size={10}
                className="    text-primary cursor-pointer   "
                onClick={(e) => {
                    setShowImage(true);
                }}
            />
        </div>} */}

    </div>
}